import { render, staticRenderFns } from "./OuterVaccinations.vue?vue&type=template&id=21246098&"
import script from "./OuterVaccinations.vue?vue&type=script&lang=js&"
export * from "./OuterVaccinations.vue?vue&type=script&lang=js&"
import style0 from "./OuterVaccinations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports